import { atom } from 'recoil';
import { IAreaPosicao } from '../../commons/styleds/historicoProdissional';

export const areaPosicaoAtom = atom<IAreaPosicao[]>({
  key: 'areaPosicao',
  default: [] as IAreaPosicao[],
});
